define('payment/handlers/formTemplateHandlers/formTemplateHandlers',['jquery', 'payment/handlers/formTemplateHandlers/bankWireTemplateHandler', 'payment/handlers/formTemplateHandlers/bankWireWithdrawTemplateHandler'],

    function($, bankWireTemplateHandler, bankWireWithdrawTemplateHandler) {
        'use strict';

        var handlers = {
            'BANK-WIRE' : bankWireTemplateHandler,
            'BANK-WIRE-WITHDRAW' : bankWireWithdrawTemplateHandler
        };

        function setupFormTemplate($formTemplate, formTemplateCode, templateData, paymentBox) {
            var eventHandler = handlers[formTemplateCode];
            if (!eventHandler) {
                return;
            }
            eventHandler.setupFormTemplate($formTemplate, templateData, paymentBox);
        }

        var formTemplateHandlers = {};
        formTemplateHandlers.setupFormTemplate = setupFormTemplate;

        return formTemplateHandlers;
    }
);

